import _ from 'lodash';
import fireShoppingFinishedEvent from './log-shopping-finished-event';

export const RECEIVE_PRODUCT_DATA = 'RECEIVE_PRODUCT_DATA';
export const SET_REDIRECT_SUPPRESSED = 'SET_REDIRECT_SUPPRESSED';
export const SET_REDIRECT_TIMEOUT = 'SET_REDIRECT_TIMEOUT';
export const SET_COMPONENT_NAME = 'SET_COMPONENT_NAME';
export const SHOW_ERROR_PAGE = 'SHOW_ERROR_PAGE';
export const SHOW_MISSING_TRACKING_PARAMS = 'SHOW_MISSING_TRACKING_PARAMS';
export const SET_IS_CJ_REDIRECT = 'SET_IS_CJ_REDIRECT';
export const SUPRESS_SPLASH_PAGE = 'SUPRESS_SPLASH_PAGE';

export const fetchAndLog =
  ({ loggerData, clientData, req, shouldLog }) =>
  async (dispatch) => {
    const dispatchData = () => {
      dispatch({
        type: RECEIVE_PRODUCT_DATA,
        product: clientData,
      });
    };

    req.log.info({
      message: 'Final destination url',
      context: {
        final_destination_url: clientData?.destinationUrl || null,
      },
    });

    // Skip firing events if suppress_tracking is set to '1'
    if (
      _.get(req, 'query.suppress_tracking', '0') === '1' ||
      _.get(!shouldLog)
    ) {
      dispatchData();
      return;
    }

    if (!loggerData) {
      req.log.error('missing logger data');
      dispatchData();
      return;
    }

    if (!clientData.redirectType) {
      await fireShoppingFinishedEvent(req, loggerData);
    }

    dispatchData();
  };

export const showMissingTrackingPrams = (missingTrackingParams) => ({
  type: SHOW_MISSING_TRACKING_PARAMS,
  missingTrackingParams,
});

export const setRedirectSuppressed = (suppressed) => ({
  type: SET_REDIRECT_SUPPRESSED,
  suppressed,
});

export const setIsCJRedirect = (isCJRedirect) => ({
  type: SET_IS_CJ_REDIRECT,
  isCJRedirect,
});

export const setRedirectTimeout = (timeout) => ({
  type: SET_REDIRECT_TIMEOUT,
  timeout,
});

export const setComponentName = (componentName) => ({
  type: SET_COMPONENT_NAME,
  componentName,
});

export const showErrorPage = () => ({
  type: SHOW_ERROR_PAGE,
});

export const supressSplashPage = () => ({
  type: SUPRESS_SPLASH_PAGE,
});
